import React from 'react'
import FormLabel from '@material-ui/core/FormLabel'
import { withStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

import { standardBodyFont } from '../../themes'
import { translate } from '../../multilanguage'

const StyledInputLabelBase = withStyles(theme => {
  return {
    root: {
      ...standardBodyFont(theme),
      color: theme.palette.text.primary,
      ...props => props.style,
    },
    focused: {
      '&$focused': {
        color: theme.palette.text.primary,
        ...props => props.style
      }
    }
  } 
})(FormLabel)

const InputLabelBase = props => {
  return (
    <StyledInputLabelBase
      style={props.style}
      className={props.className}
    >
      {typeof props.children !== 'string' ? props.children : props.noTranslate ? props.children : translate(props.children)}
    </StyledInputLabelBase>
  )
}

InputLabelBase.propTypes = {  
  style: PropTypes.object,
  children: PropTypes.node.isRequired,
  noTranslate: PropTypes.bool,
  className: PropTypes.string,
}

export default InputLabelBase